/**
 * Possible templates which can be specified. For suggested template
 * modifications, default values and template flow, please consult the
 * integration documentation.
 *
 * @public
 */
export enum Templates {
	/**
	 * This will be displayed when there is nothing currently being shown by the
	 * instance of the SDK. An example of this would be when the SDK is loading
	 * data from the server prior to the authentication checks.
	 */
	None = 'none',
	/**
	 * This will be displayed whilst the SDK is initialising and will be
	 * overwritten by the first provider when initialised.
	 */
	Initializing = 'initializing',
	/**
	 * This will be displayed when the customer has elected to use the camera
	 * for document capture rather than a file upload.
	 */
	Camera = 'camera',
	/**
	 * This will be displayed when the customer has elected to use the cropping
	 * functionality offered by the SDK. The customer will be able to select
	 * "Crop" to submit the cropped file, or "Cancel" to return to the capture
	 * screen.
	 */
	Cropper = 'cropper',
	/**
	 * This will be displayed when the customer has elected to use the browser's
	 * default media picker to select a document. The customer will be able to
	 * either use the media picker, or drop a file onto the specified area to
	 * continue.
	 */
	Filesystem = 'filesystem',
	/**
	 * This will be displayed when the customer has started the journey and is
	 * at the front or rear document capture stage, and not using the
	 * SmartCapture document capture provider.
	 */
	Gateway = 'gateway',
	/**
	 * This will be displayed to the customer when they are at the liveness
	 * stage of the journey. Pose instructions will be automatically displayed
	 * to the customer providing the required elements are present.
	 */
	Liveness = 'liveness',
	PassiveLiveness = 'passiveLiveness',
	/**
	 * This will be displayed at the start of the process if authentication is
	 * enabled or there is no token present in the configuration.
	 */
	Login = 'login',
	/**
	 * This will be displayed to the customer at the end of the journey and will
	 * display the outcome of the journey with any supporting information. To
	 * omit pieces of information from the view, remove the element in the
	 * template and it will be skipped. For information about which details will
	 * be made available, please consult the integration documentation.
	 */
	Result = 'result',
	/**
	 * This will be displayed when the customer is at any document capture stage
	 * in the journey and the scanner capture method has been specified by the
	 * server. Details and status updates will be automatically displayed as and
	 * when required.
	 */
	Scanner = 'scanner',
	/**
	 * This will be displayed to the customer when they have captured an image
	 * using the camera provider or the filesystem providers. The customer can
	 * choose to upload the image as is, or use the cropping functionality to
	 * trim the image before uploading. To disable the cropping functionality,
	 * omit the button from the template.
	 */
	View = 'view',
	/**
	 * This will be displayed to the customer when the smart capture provider
	 * has been specified by the server. The customer can click start to begin
	 * the document capture.
	 */
	SmartCapture = 'smartCapture',
	/**
	 * This will be displayed when presenting the user with a list of the
	 * available journeys. The user will be able to see a list of the journeys
	 * which are configured in the back office, and pick from one. If there is
	 * only one journey available, this screen will be bypassed. If there are
	 * none configured, an error message will be shown.
	 */
	JourneySelect = 'journeySelect',
	TripleScanGuidance = 'tripleScanGuidance',
	HasNoCamera = 'hasNoCamera',
	Covid = 'covid',
	DataChecks = 'dataChecks',
	TermsAndConditions = 'termsAndConditions'
}
